import { GridColDef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { useHostPlayersAudit } from "services/api/SWRService";
import { IHostPlayerAudit as IGuestHostAudit } from "services/models/Host/HostGuestAudit";
import { dateCol, tierCol } from "utils/datagrid-utils";
import { PlayerNameCell } from "./PlayerNameCell";
import { SWRDataGrid } from "./SWRDataGrid";
import { GridPaginationProps } from "./helpers";
import { useMobile } from "hooks/Mobile/useMobile";
import { filterPanelSx } from ".";
import { PLAYER_NAME_MIN_WIDTH } from "constants/tables";

const columns: GridColDef<IGuestHostAudit>[] = [
  {
    field: "currentTier",
    headerName: "Tier",
    ...tierCol,
  },
  {
    field: "fullName",
    headerName: "Player",
    flex: 1,
    minWidth: PLAYER_NAME_MIN_WIDTH,
    renderCell: ({ row }) => <PlayerNameCell {...row} />,
  },
  {
    field: "previousHostName",
    headerName: "Previously Assigned",
    minWidth: 150,
    valueFormatter: ({ value }) => value ?? "No Host",
  },
  {
    field: "currentHostName",
    headerName: "Currently Assigned",
    minWidth: 150,
  },
  {
    field: "dateTimeOfReassignment",
    headerName: "Date Changed",
    ...dateCol,
    minWidth: 130,
    valueFormatter: ({ value }) => moment(value).format("MM/DD/YY"),
  },
];

export const GuestAndHostAuditTable = (props: GridPaginationProps): JSX.Element => {
  const response = useHostPlayersAudit();
  const isMobile = useMobile();

  return (
    <SWRDataGrid
      initialState={{
        columns: {
          columnVisibilityModel: {
            currentTier: false,
          },
        },
        sorting: {
          sortModel: [{ field: "dateTimeOfReassignment", sort: "desc" }],
        },
      }}
      {...props}
      name={"host-and-guest-audit"}
      response={response}
      columns={columns}
      slotProps={{
        filterPanel: isMobile ? filterPanelSx : undefined,
      }}
      noRowsMessage="No Audits Found"
    />
  );
};
